<template>
  <section class="section--pd-md">
    <div class="inner">
      <p class="_mg-b40-30 _l-md">
        MELON TVでは、過去に開催されたクラスの一部をアーカイブ動画としてご覧いただけます。
      </p>
    </div>
  </section>
</template>
<script>
export default {
  name: 'MelonTVGuide'
}
</script>
